import React from 'react'
import InternshipBg from '../../../assets/internship-bg.png'
import Navigator from '../../../components/common/Navigator'
import { useRti } from '../api'

const Rti = () => {
  const { data, isLoading, isError } = useRti()

  if (isLoading) return <div className="text-center p-4">Loading...</div>
  if (isError)
    return (
      <div className="text-center p-4 text-red-500">Something went wrong.</div>
    )
  const formattedDescription = data?.description?.replace(
    /<p><strong>(.*?)<\/strong><\/p>/g,
    '<p class="my-6 text-lg font-semibold text-gray-800"><strong>$1</strong></p>'
  )

  return (
    <div className="lg:w-11/12 mx-auto p-4 lg:p-0 lg:my-8">
      <Navigator title="RTI" slug="RTI" />
      <h1 className="text-3xl font-semibold text-gray-800  pb-2">RTI</h1>
      <hr className="border-t-2 border-primaryBlue mb-6" />
      <div
        className="bg-cover bg-center bg-no-repeat rounded-xl py-8 md:py-12 lg:py-16"
        style={{
          backgroundImage: `url(${InternshipBg})`,
        }}
      >
        <div className="px-4 md:px-14">
          <div className="grid grid-cols-1 lg:grid-cols-1 gap-8 lg:gap-16 items-center">
            <div className="bg-white/90 backdrop-blur-sm p-6 md:p-8 lg:p-10 rounded-lg min-h-[450px] shadow">
              {/* <p className="text-gray-900 text-sm md:text-base tracking-wide leading-relaxed">
                {data?.description?.replace(/<\/?[^>]+(>|$)/g, '')}
              </p> */}
              {/* <div
                className="text-gray-900 text-sm md:text-base tracking-wide leading-relaxed"
                dangerouslySetInnerHTML={{ __html: data?.description || '' }}
              /> */}
              <div
                className="text-gray-900 text-sm md:text-base tracking-wide leading-relaxed"
                dangerouslySetInnerHTML={{ __html: formattedDescription || '' }}
              />
            </div>
            <div className="w-full flex justify-center items-center"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Rti
